var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9334 14.7836H16.207L18.5377 0.263199H22.2639L19.9334 14.7836Z",
    fill: "#00579F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4416 0.618176C32.7066 0.324376 31.5409 -1.52588e-05 30.0994 -1.52588e-05C26.4195 -1.52588e-05 23.8282 1.97713 23.8123 4.80385C23.7818 6.88939 25.6676 8.04776 27.0781 8.74314C28.5198 9.45372 29.0099 9.91752 29.0099 10.5509C28.9952 11.5237 27.8449 11.9721 26.7721 11.9721C25.2843 11.9721 24.4872 11.7409 23.2758 11.1997L22.7851 10.9677L22.2637 14.2272C23.1376 14.6284 24.7478 14.9844 26.4195 15C30.3295 15 32.8749 13.0534 32.9051 10.0411C32.92 8.38816 31.9242 7.1216 29.7772 6.08663C28.4739 5.42224 27.6758 4.97425 27.6758 4.29447C27.6911 3.67648 28.3509 3.04351 29.8221 3.04351C31.0335 3.01251 31.9235 3.3059 32.5978 3.59949L32.9349 3.75368L33.4416 0.618176Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3941 9.63953C38.701 8.80536 39.8819 5.57685 39.8819 5.57685C39.8664 5.60785 40.1881 4.72727 40.3721 4.18669L40.6325 5.43785C40.6325 5.43785 41.3382 8.91356 41.4914 9.63953C40.909 9.63953 39.1301 9.63953 38.3941 9.63953ZM42.9938 0.263199H40.1115C39.2227 0.263199 38.5474 0.525586 38.1639 1.46796L32.6289 14.7834H36.5388C36.5388 14.7834 37.1825 12.9912 37.3209 12.6052C37.7498 12.6052 41.5534 12.6052 42.1052 12.6052C42.2122 13.115 42.5498 14.7834 42.5498 14.7834H46L42.9938 0.263199Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0945 0.263199L9.4452 10.1647L9.04642 8.15658C8.37174 5.83944 6.25581 3.32192 3.89453 2.07014L7.23716 14.7682H11.1776L17.0348 0.263199H13.0945Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05662 0.263199H0.0613342L0 0.556588C4.6767 1.76156 7.77399 4.66609 9.04652 8.15719L7.74322 1.48377C7.52865 0.556383 6.86925 0.29379 6.05662 0.263199Z",
    fill: "#FAA61A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.fcd1c7a0.svg";
export { ForwardRef as ReactComponent };